import { useTranslate } from '@repo/shared/hooks'
import { Link } from '@repo/shared/i18n/navigation'
import { Button, Card, Col, Typography } from '@repo/ui/components'
import Image from 'next/image'

export const DashboardSquareToken = () => {
  const { t } = useTranslate()
  return (
    <Card
      as={Link}
      href='/square-token'
      className='relative p-md md:p-lg items-center gap-md md:gap-xl overflow-hidden rounded-b-none sm:rounded-b-md'
      style={{
        boxShadow:
          '0px 2px 8px -2px var(--color-black-5), 0px 1px 2px 0px var(--color-black-5)',
      }}
    >
      <div className='absolute -top-lg -left-lg w-[72px] h-[72px] bg-primary-main rounded-sm -rotate-12'>
        <Image
          src='/images/club-gem.svg'
          sizes='72px'
          priority
          alt='Club Gem'
          fill
          className='object-cover'
        />
      </div>

      <Image
        src='/images/club-gem.svg'
        sizes='20px'
        priority
        alt='Club Gem'
        width={32}
        height={32}
        className='object-cover'
      />

      <div className='absolute -bottom-lg -right-lg w-[72px] h-[72px] rotate-[30deg] z-10'>
        <Image
          src='/images/club-gem.svg'
          priority
          alt='Club Gem'
          fill
          className='object-cover blur-xs'
        />
      </div>
      <Col className='items-center gap-md md:gap-xl'>
        <Typography
          size='lg'
          weight='bold'
          className='text-neutral-surface-100 md:text-xl'
        >
          {t('dashboard_square_token_title')}
        </Typography>
        <Typography
          size='xs'
          className='text-neutral-surface-100 text-center md:text-sm'
        >
          {t('dashboard_square_token_desc')}
        </Typography>
        <Button size='sm' color='neutral' className='w-full md:text-md'>
          {t('dashboard_square_token_cta')}
        </Button>
      </Col>
    </Card>
  )
}
